import { MediaContentShowcaseItem } from 'onnit-ui/lib/module/MediaContentShowcase';

const ingredientsFuelBend: MediaContentShowcaseItem[] = [
    {
        image: `pterostilbene.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Pterostilbene',
        summary: 'A derivative of resveratrol with similar properties.',
        detail: 'Promotes cellular integrity, helping to protect brain and nerve cells.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `l-leucine.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'L-Leucine',
        summary: 'A branched-chain amino acid (BCAA).',
        detail: 'Helps the body synthesize protein.<span class="oui-sup">&dagger;</span>.',
    }
];

export default ingredientsFuelBend;
